import { render } from "./reset_password.vue?vue&type=template&id=45a0f910"
import script from "./reset_password.vue?vue&type=script&lang=js"
export * from "./reset_password.vue?vue&type=script&lang=js"

import "./reset_password.vue?vue&type=style&index=0&id=45a0f910&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__